


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const quotationToInvoiceReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.QUOTATION_TO_INVOICE:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.QUOTATION_TO_INVOICE_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.QUOTATION_TO_INVOICE_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
